import { cloneDeep } from "lodash";
import { ADD_FORCES_INPUT_ERROR, ADD_FORCES_INPUT_STARTING, ADD_FORCES_INPUT_SUCCESS } from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function addForcesInputReducer(
  state = initialState.addForcesInput,
  action
) {
  switch (action.type) {
    case ADD_FORCES_INPUT_STARTING: {
      const newState = cloneDeep(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_FORCES_INPUT_SUCCESS: {
      const { data } = action;
      const newState = cloneDeep(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newForcesInput = data.forcesInput;
      return newState;
    }

    case ADD_FORCES_INPUT_ERROR: {
      const newState = cloneDeep(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}